import React, { useEffect, useRef, useState } from "react";
import "./PapayaAbout.scss"
import award from "../assets/award.svg"
import exp from "../assets/exp.svg"
import tick from "../assets/tick.svg"
import chilli from "../assets/chilli.svg"
import Button from "../components/Button/Button";
import arrowDown from "../assets/dwn-arr-white.svg"
import arrowUp from "../assets/up-arr-yell.svg"
import { useSelector } from "react-redux";
import { sortByOrderAscending } from "../helper/helper";
import ThreeDotSlider from "../components/ThreeDotSlider/ThreeDotSlider ";
import CustomVideoPlayer from "../components/CustomVideoPlayer/CustomVideoPlayer";

const PapayaAbout = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "about")
    const Components = page?.Components || []

    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const [show, setShow] = useState(0)
    const [questionCount, setQuestionCount] = useState(7)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);
    const convertToLinks = (text, url) => {
        return text.replace(/\*\/(.*?)\/\*/g, (match, p1) => {
            const url = 'https://reserve.witmeg.com/booking/slots/63bff48dc175635e907fbbf6';
            return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#FB923C">${p1}</a>`;
        });
    };

    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "PapayaAbout-Hero-header":
                return <div className="PapayaAbout-Hero-header">
                    {component?.Props?.text}

                </div>
            case "PapayaAbout-Hero-subheader":
                return <div className="PapayaAbout-Hero-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaAbout-Hero-awards":
                return <div className="PapayaAbout-Hero-cont"> <img alt="" src={award} className="PapayaAbout-Hero-cont-award" />
                    <div className="PapayaAbout-Hero-cont-content">
                        <div className="PapayaAbout-Hero-cont-content-hdr">
                            What is Travellers’ Choice?</div>
                        <div className="PapayaAbout-Hero-cont-content-txt">
                            Tripadvisor gives a Travellers’ Choice award to accommodations, attractions and restaurants that consistently earn great reviews from travellers and are ranked within the top 10% of properties on Tripadvisor.</div>
                    </div>
                </div>

            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="PapayaAbout-Hero"
                style={{
                    backgroundImage: ` linear-gradient(rgba(14, 17, 13, 0.7), rgba(14, 17, 13, 0.7)), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}

            </div>
        )
    }
    const getImagesCarousel = (data) => {
        return (
            <div className="PapayaAbout-ImageCarousel" ref={containerRef}>
                <div className="PapayaAbout-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        data?.src.includes(".mp4") ?
                            <CustomVideoPlayer
                                src={data?.src} key={index} /> : <img key={index} src={data?.src} alt={`img-${index}`} className="PapayaAbout-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const getRightAboutComponents = (component) => {
        switch (component.ID) {
            case "PapayaAbout-Content-right-subheader":
                return <div className="PapayaAbout-Content-right-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaAbout-Content-right-header":
                return <div className="PapayaAbout-Content-right-header">
                    {component?.Props?.header} <span> {component?.Props?.headerHighlight}</span>
                </div>
            case "PapayaAbout-Content-right-content":
                return <div className="PapayaAbout-Content-right-content">
                    {component?.Props?.content}
                </div>
            case "PapayaAbout-Content-right-list":
                return <div className="PapayaAbout-Content-right-list">
                    {component?.Data.map((value, key) => {
                        return (
                            <div className="PapayaAbout-Content-right-list-item" key={key}>
                                <div className="PapayaAbout-Content-right-list-item-check">
                                    <img alt="" src={tick} /></div>   {value.text}
                            </div>
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    const getRightAboutContent = (components) => {
        return (
            <div className="PapayaAbout-Content-right">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getRightAboutComponents(component)
                    )
                })}
            </div>
        )
    }
    const getLeftAboutContent = (props) => {
        return (
            <div className="PapayaAbout-Content-left">
                <img alt="" src={props.src} className="PapayaAbout-Content-left-img" />
                <div className="PapayaAbout-Content-left-exp">
                    <img alt="" src={exp} className="PapayaAbout-Content-left-exp-img" />
                    {props.text}
                </div>
                <div className="PapayaAbout-Content-left-chef">
                    <img alt="" src={props.chefSrc} className="PapayaAbout-Content-left-chef-img" />

                </div>
            </div>
        )
    }
    const getAboutComponent = (component) => {
        switch (component.ID) {
            case "PapayaAbout-Content-left":
                return getLeftAboutContent(component?.Props)
            case "PapayaAbout-Content-right":
                return getRightAboutContent(component?.Components)
            default:
                return <div />
        }

    }
    const getAboutContent = (components) => {
        return (
            <div className="PapayaAbout-Content">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getAboutComponent(component)
                    )
                })}
            </div>
        )
    }
    const getLeftAboutContent3Components = (component) => {
        switch (component.ID) {
            case "PapayaAbout-Content3-left-subheader":
                return <div className="PapayaAbout-Content3-flex-left-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaAbout-Content3-left-header":
                return <div className="PapayaAbout-Content3-flex-left-header">
                    {component?.Props?.text}
                </div>
            case "PapayaAbout-Content3-left-content":
                return <div className="PapayaAbout-Content3-flex-left-content">
                    {component?.Props?.content}
                </div>
            case "PapayaAbout-Content3-left-list":
                return <div className="PapayaAbout-Content3-flex-left-list">
                    {component?.Data.map((value, key) => {
                        return (
                            <div className="PapayaAbout-Content3-flex-left-list-item" key={key}>
                                <div className="PapayaAbout-Content3-flex-left-list-item-check">
                                    <img alt="" src={tick} /></div>   {value.text}
                            </div>
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    const getLeftAboutContent3 = (components) => {
        return (
            <div className="PapayaAbout-Content3-flex-left">

                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getLeftAboutContent3Components(component)
                    )
                })}
            </div>

        )
    }
    const getAboutComponent3 = (component) => {
        switch (component.ID) {
            case "PapayaAbout-Content3-left":
                return getLeftAboutContent3(component?.Components)
            case "PapayaAbout-Content-right":
                return <img alt="" src={component?.Props?.src} className="PapayaAbout-Content3-flex-right" />

            default:
                return <div />
        }

    }
    const getAboutContent3 = (props, components) => {
        return (
            <div className="PapayaAbout-Content3">
                <img alt="" src={chilli} className="chilli" />
                <div className="PapayaAbout-Content3-subheader">
                    <span />    {props.subheader}
                </div>
                <div className="PapayaAbout-Content3-header">
                    <div className="div1">{props.header}
                    </div><div className="div2"><div className="div1">{props.header2}</div> {props.headerHighlight}</div>
                </div>
                <div className="PapayaAbout-Content3-flex">
                    {sortByOrderAscending(components).map((component, key) => {
                        return (
                            getAboutComponent3(component)
                        )
                    })}
                </div>
            </div >
        )
    }
    const getAboutusContentList = (components) => {
        return (
            <div className="PapayaAbout-Content2">
                {components?.map((data, key) => {
                    return (
                        <div className="PapayaAbout-Content2-List" key={key}>
                            <div className="PapayaAbout-Content2-List-left">
                                <img alt="" src={data?.icon} />
                            </div>
                            <div className="PapayaAbout-Content2-List-right">
                                <div className="PapayaAbout-Content2-List-right-header">
                                    {data?.header}
                                </div>
                                <div className="PapayaAbout-Content2-List-right-subheader">
                                    {data?.subheader}
                                </div>
                            </div>


                        </div>
                    )
                })}
            </div>
        )
    }
    const getVideoPlayer = (src) => {
        return (

            <div className="PapayaAbout-Video"
                style={{
                    backgroundImage: `linear-gradient(270deg, rgba(31, 33, 32, 0) 0%, rgba(31, 33, 32, 0.6) 80.94%), url(${src})`
                }} />
        )
    }
    const getAboutusContent4Component = (component) => {
        switch (component.ID) {
            case "PapayaAbout-Content4-subheader":
                return <div className="PapayaAbout-Content4-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaAbout-Content4-header":
                return <div className="PapayaAbout-Content4-header">
                    <div className="div1">    {component?.Props?.header}

                    </div><div className="div2">    {component?.Props?.headerHighlight}</div>

                </div>
            case "PapayaAbout-Content4-list":
                return <div className="PapayaAbout-Content4-list">
                    {component?.Data.map((item, key) => {
                        return (
                            <div key={key} className="PapayaAbout-Content4-list-item">
                                <img alt="" src={item?.src} />
                                <div className="PapayaAbout-Content4-list-item-name">
                                    {item?.name}
                                </div>
                            </div>
                        )
                    })}

                </div>
            default:
                return <div />
        }

    }
    const getAboutusContent4 = (components) => {
        return (
            <div className="PapayaAbout-Content4">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getAboutusContent4Component(component)
                    )
                })}
            </div>
        )
    }
    const getAboutusTestimonialsComponent = (component) => {
        switch (component.ID) {
            case "PapayaAbout-Testimonials-subheader":
                return <div className="PapayaAbout-Testimonials-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaAbout-Testimonials-header":
                return <div className="PapayaAbout-Testimonials-header">
                    <div className="div1">    {component?.Props?.header}

                    </div><div className="div2">    {component?.Props?.headerHighlight}</div>

                </div>
            case "PapayaAbout-Testimonials-list":
                return <>
                    <ThreeDotSlider
                        slides={component?.Data} />

                </>
            default:
                return <div />
        }

    }
    const getAboutusTestimonials = (src, components) => {
        return (
            <div className="PapayaAbout-Testimonials"
                style={{
                    backgroundImage: ` linear-gradient(rgba(14, 17, 13, 0.7), rgba(14, 17, 13, 0.7)), url(${src})`
                }} >
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getAboutusTestimonialsComponent(component)
                    )
                })}
            </div>
        )
    }
    const getLeftAboutContent5 = (component, questionData) => {
        switch (component.ID) {
            case "PapayaAbout-Content5-flex-left-subheader":
                return <div className="PapayaAbout-Content5-flex-left-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaAbout-Content5-flex-left-header":
                return <div className="PapayaAbout-Content5-flex-left-header">
                    {component?.Props?.header}
                    <div className="PapayaAbout-Content5-flex-left-header-highlight">{component?.Props?.headerHighlight}</div>
                </div>
            case "PapayaAbout-Content5-flex-left-content":
                return <div className="PapayaAbout-Content5-flex-left-content">
                    {component?.Props?.content}</div>

            default:
                return <div />
        }

    }
    const getAboutContent5Component = (component) => {
        switch (component.ID) {
            case "PapayaAbout-Content5-flex-left":
                return <div className="PapayaAbout-Content5-flex-left">
                    {sortByOrderAscending(component?.Components, component?.Data).map((data, key) => {
                        return (
                            getLeftAboutContent5(data)
                        )
                    })}</div>
            case "PapayaAbout-Content5-flex-right":
                return <div className="PapayaAbout-Content5-flex-right">
                    {component?.Data?.slice(0, questionCount).map((value, key) => {
                        return (
                            <div className="PapayaAbout-Content5-flex-right-list">
                                <div className="PapayaAbout-Content5-flex-right-list-qt"
                                    onClick={() => {
                                        if (show === key + 1) {
                                            setShow(0)
                                        } else {
                                            setShow(key + 1)
                                        }
                                    }}>{key + 1}. {value?.questions}
                                    <div className={show === key + 1 ? "PapayaAbout-Content5-flex-right-list-qt-arr2" : "PapayaAbout-Content5-flex-right-list-qt-arr"}>
                                        <img alt="" src={show === key + 1 ? arrowUp : arrowDown} /></div>
                                </div>
                                {(show === key + 1) && <div className="PapayaAbout-Content5-flex-right-list-ans" dangerouslySetInnerHTML={{ __html: convertToLinks(value?.answer, value?.href || "") }} />
                                }  </div>
                        )
                    })}
                </div>
            case "PapayaAbout-Content5-flex-button":
                return <Button
                    text={questionCount !== 7 ? "View less" : component?.Props?.btnText}
                    isArrow={component?.Props?.isArrow}
                    onClick={() => {
                        if (questionCount === 7) {
                            setQuestionCount(component?.Data?.length)
                        }
                        else {
                            setQuestionCount(7)
                        }
                    }} />
            default:
                return <div />
        }

    }

    const getAboutContent5 = (components) => {
        return (
            <div className="PapayaAbout-Content5">
                <div className="PapayaAbout-Content5-flex">

                    {sortByOrderAscending(components).map((component, key) => {
                        return (
                            getAboutContent5Component(component)
                        )
                    })}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "PapayaAbout-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "PapayaAbout-Content":
                return getAboutContent(component.Components)
            case "PapayaAbout-Content2-List":
                return getAboutusContentList(component?.Data)
            case "PapayaAbout-Content3":
                return getAboutContent3(component?.Props, component?.Components)
            case "PapayaAbout-Player":
                return getVideoPlayer(component?.Props?.src)
            case "PapayaAbout-Content4":
                return getAboutusContent4(component.Components)
            case "PapayaAbout-Testimonials":
                return getAboutusTestimonials(component?.Props?.bgSrc, component.Components)
            case "PapayaAbout-ImageCarousel":
                return getImagesCarousel(component.Data)
            case "PapayaAbout-Content5":
                return getAboutContent5(component.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="PapayaAbout">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )
}
export default PapayaAbout